<template>
    <div>
        <span class="badge badge-dark" v-html="item.type"></span>
        <h5 class="_title" v-html="item.name"></h5>
        <div class="_description" v-html="item.description"></div>
    </div>
</template>

<script>
export default {
    props: {
        item: { required: true },
        searchText: { required: true },
    }
}
</script>
